"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2PopOverTablet = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_menu_v2_constants_1 = require("../bc-menu-v2-constants");
var helpers_1 = require("../../../../common/helpers");
var bc_pop_over_constants_1 = require("../../../atoms/bc-pop-over/bc-pop-over-constants");
var bc_pop_over_behavior_1 = require("../../../atoms/bc-pop-over/bc-pop-over-behavior");
var BcMenuV2PopOverTablet = (function () {
    function BcMenuV2PopOverTablet(config) {
        this.menu = config.menu;
        this.listItemsMenuArr = config.listItemsMenuArr;
        this.subMenuConfig = config.subMenuConfig;
        this.configHeaderTablet = config.configHeaderTablet;
        this.setListennerLinksResponsive = config.setListennerLinksResponsive;
        this.listennerItemsNotPopOvers = config.listennerItemsNotPopOvers;
        this.arrayInstancesPopOver = config.arrayInstancesPopOver;
        this.configClickListener = config.configClickListener;
        this.setAccesibilityAriaFalse = config.setAccesibilityAriaFalse;
        this.render();
    }
    BcMenuV2PopOverTablet.prototype.render = function () {
        this.createPopOvers(this.menu, this.listItemsMenuArr, this.subMenuConfig);
    };
    BcMenuV2PopOverTablet.prototype.createPopOvers = function (menu, listItemsMenuArr, subMenuConfig) {
        var _this = this;
        var _loop_1 = function (index) {
            var elementA = listItemsMenuArr[index];
            var position = this_1.getPositionPopOver(index, subMenuConfig);
            if (elementA.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2))) {
                if (!document.getElementById("".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2, "-").concat(index))) {
                    var popOverContainer = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.SECTION_TAG, classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER] });
                    var popOverElement = (0, helpers_1.createElement)({
                        element: common_constants_1.BcCommonConstants.SECTION_TAG,
                        classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_TARGET, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_TABLET],
                        props: { id: "".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2, "-").concat(index), hiddenArrow: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE, position: position },
                        children: [popOverContainer],
                    });
                    var bodyElement = document.querySelector(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_BODY);
                    bodyElement.prepend(popOverElement);
                    elementA.setAttribute(common_constants_1.BcCommonConstants.ARIA_CONTROL, "".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2, "-").concat(index));
                    elementA.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_TARGET);
                    elementA.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.BUTTON_TAG);
                    var megaMenuClone = elementA.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2)).cloneNode(true);
                    this_1.configHeaderTablet(subMenuConfig.header, megaMenuClone);
                    var stroke = megaMenuClone.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FOOTER_STROKE));
                    if (stroke) {
                        stroke.remove();
                    }
                    this_1.configPopOversBehavior(elementA, megaMenuClone, index);
                    popOverContainer.append(megaMenuClone);
                    this_1.setListennerLinksResponsive(megaMenuClone, elementA);
                }
            }
            else {
                elementA.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                    if (window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
                        _this.listennerItemsNotPopOvers(elementA, event);
                    }
                });
            }
        };
        var this_1 = this;
        for (var index = 0; index < listItemsMenuArr.length; index++) {
            _loop_1(index);
        }
    };
    BcMenuV2PopOverTablet.prototype.getPositionPopOver = function (index, subMenuConfig) {
        var listLength = subMenuConfig === null || subMenuConfig === void 0 ? void 0 : subMenuConfig.listItemsMenu.length;
        var firstIndex = index === 0;
        if (listLength > common_constants_1.COMMON_CONSTANTS_NUMBERS.N4) {
            if (index === common_constants_1.COMMON_CONSTANTS_NUMBERS.N3 || index === common_constants_1.COMMON_CONSTANTS_NUMBERS.N4) {
                return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP_LEFT;
            }
            if (firstIndex || index === 1) {
                return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP_RIGHT;
            }
        }
        else if (listLength < common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && listLength > common_constants_1.COMMON_CONSTANTS_NUMBERS.N1) {
            var lastIndex = (subMenuConfig === null || subMenuConfig === void 0 ? void 0 : subMenuConfig.listItemsMenu.length) - 1;
            if (index === lastIndex) {
                return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP_LEFT;
            }
            if (firstIndex) {
                return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP_RIGHT;
            }
        }
        return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP;
    };
    BcMenuV2PopOverTablet.prototype.configPopOversBehavior = function (aElement, clone, index) {
        var _this = this;
        var popoverInstance = new bc_pop_over_behavior_1.BcPopOverBehavior();
        this.arrayInstancesPopOver.push(popoverInstance);
        var itemTargetli = aElement.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        itemTargetli.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.configClickListener(popoverInstance, itemTargetli);
        });
        popoverInstance.setId("".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2, "-").concat(index));
        popoverInstance.setUp();
        clone.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
        clone.style.position = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_STATIC;
        clone.style.maxHeight = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N500X;
        clone.style.left = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_AUTO;
        clone.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_AUTO;
        var buttonHeaderMegaMenu = clone.firstChild.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        buttonHeaderMegaMenu.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.onDeleteClassPressItems();
            popoverInstance.closePopOver();
            _this.setAccesibilityAriaFalse(itemTargetli);
        });
        aElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var allowedKeyCodes = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, common_constants_1.BcCommonConstants.KEY_EVENT_SPACE];
            if (allowedKeyCodes.includes(event.code)) {
                _this.configClickListener(popoverInstance, itemTargetli);
            }
        });
    };
    return BcMenuV2PopOverTablet;
}());
exports.BcMenuV2PopOverTablet = BcMenuV2PopOverTablet;
